import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";

export const UploadFileCardTemplateTexts = () => {
  return {
    uploadText: t("Upload"),
    elapsedText: t("elapsed"),
    remainingText: t("remaining"),
    speedText: t("speed"),
    removeText: t("remove"),
    cancelText: t("cancel"),
    resumeText: t("resume"),
    pauseText: t("pause"),
    waitingText: t("waiting"),
    pausingText: t("pausing"),
    cancelingText: t("canceling"),
    overwriteText: t("overwrite"),
    reuploadText: t("reupload"),
    averageSpeedText: t("averageSpeed"),
    detailsTet: t("details"),
    finalizingText: t("finalizing"),
  };
};
